import memoWithDisplayName from '../../utils/memoWithDisplayName';
import { useTheme } from 'foundations-theming-specialty/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const EmptyFavoritesSubmenuSvg = memoWithDisplayName('EmptyFavoritesSubmenuSvg', ({
  id,
  testId
}) => {
  const theme = useTheme();
  return /*#__PURE__*/_jsxs("svg", {
    id: id,
    width: "170",
    height: "112",
    viewBox: "0 0 170 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-test-id": testId,
    children: [/*#__PURE__*/_jsx("rect", {
      x: "8",
      y: "12",
      width: "154",
      height: "24",
      rx: "4",
      fill: theme.color['global-shell-fill-sub-nav-item-hover']
    }), /*#__PURE__*/_jsx("rect", {
      x: "20",
      y: "20",
      width: "85.5556",
      height: "8",
      rx: "4",
      fill: theme.color['global-shell-fill-surface-panel-default']
    }), /*#__PURE__*/_jsx("rect", {
      x: "8",
      y: "44",
      width: "154",
      height: "24",
      rx: "4",
      fill: theme.color['global-shell-text-nav-item-default']
    }), /*#__PURE__*/_jsx("rect", {
      x: "20",
      y: "52",
      width: "65.5742",
      height: "8",
      rx: "4",
      fill: theme.color['global-shell-fill-surface-panel-default']
    }), /*#__PURE__*/_jsx("rect", {
      x: "8",
      y: "76",
      width: "154",
      height: "24",
      rx: "4",
      fill: theme.color['global-shell-fill-sub-nav-item-hover']
    }), /*#__PURE__*/_jsx("rect", {
      x: "20",
      y: "84",
      width: "99.3548",
      height: "8",
      rx: "4",
      fill: theme.color['global-shell-fill-surface-panel-default']
    }), /*#__PURE__*/_jsx("path", {
      d: "M147.938 50.9412V61.0624C147.938 61.2162 147.847 61.3512 147.705 61.4112C147.66 61.4299 147.611 61.4374 147.562 61.4374C147.465 61.4374 147.368 61.3999 147.296 61.3249L144.049 58.0324L140.7 61.3287C140.595 61.4374 140.434 61.4674 140.295 61.4074C140.152 61.3512 140.062 61.2124 140.062 61.0624V50.9412C140.062 50.7312 140.231 50.5662 140.438 50.5662H147.562C147.769 50.5662 147.938 50.7312 147.938 50.9412Z",
      fill: theme.color['global-shell-fill-surface-panel-default']
    })]
  });
});